import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'Buyers',
    href: '#'
  }, {
    name: 'Sellers',
    href: '#'
  }, {
    name: 'Search Homes',
    href: '#'
  }, {
    name: 'About',
    href: '#'
  }, {
    name: 'Why Us',
    href: '#'
  }, {
    name: 'Contact',
    href: '#'
  }];
  return <>
      <header className={`fixed w-full z-40 transition-all duration-300 ${isScrolled ? 'bg-ivory/95 backdrop-blur-sm shadow-sm py-3 md:py-4 md:top-0' : 'bg-transparent py-4 md:py-6 md:top-[37px]'}`} data-id="element-232">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 flex justify-between items-center" data-id="element-233">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3 group" data-id="element-234">
            <img src="https://cdn.magicpatterns.com/uploads/vNvN1XWtPWy9K7eBdDVvNB/Beshk-group-logo-icon.png" alt="The Beshk Group" className="w-8 h-8 md:w-11 md:h-11 object-contain shrink-0" data-id="element-235" />
            <div className="flex flex-col items-start" data-id="element-236">
              <span className={`font-serif text-xl md:text-2xl tracking-tight uppercase transition-colors ${isScrolled ? 'text-charcoal' : 'text-white'}`} data-id="element-237">
                The Beshk Group
              </span>
              <div className={`h-[1px] w-0 group-hover:w-full bg-terracotta transition-all duration-300 mt-1`} data-id="element-238" />
              <span className={`text-[8px] md:text-[9px] tracking-widest uppercase mt-1 transition-colors ${isScrolled ? 'text-muted-gray' : 'text-white/80'}`} data-id="element-239">
                Selling Real Estate One Relationship at a Time
              </span>
            </div>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center space-x-8" data-id="element-240">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium hover:text-terracotta transition-colors relative group ${isScrolled ? 'text-charcoal-text' : 'text-white'}`} data-id="element-241">
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-terracotta transition-all duration-300 group-hover:w-full" data-id="element-242"></span>
              </a>)}
            <a href="#" className="bg-terracotta text-white px-6 py-2.5 rounded text-sm font-medium hover:bg-terracotta/90 transition-colors shadow-sm" data-id="element-243">
              Get Home Value
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className={`lg:hidden p-3 ml-2 ${isScrolled ? 'text-charcoal' : 'text-white'}`} onClick={() => setIsMobileMenuOpen(true)} aria-label="Open menu" data-id="element-244">
            <Menu className="w-6 h-6" data-id="element-245" />
          </button>
        </div>
      </header>

      {/* Mobile Menu Drawer */}
      <div className={`fixed inset-0 bg-charcoal/40 backdrop-blur-sm z-50 transition-opacity duration-300 lg:hidden ${isMobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-246">
        <div className={`absolute right-0 top-0 bottom-0 w-[80%] max-w-sm bg-ivory shadow-2xl transition-transform duration-300 ease-out flex flex-col ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} onClick={e => e.stopPropagation()} data-id="element-247">
          <div className="flex justify-between items-center p-6 border-b border-sand" data-id="element-248">
            <span className="font-serif text-xl text-charcoal" data-id="element-249">Menu</span>
            <button onClick={() => setIsMobileMenuOpen(false)} className="p-2 -mr-2 text-charcoal-text hover:text-terracotta" aria-label="Close menu" data-id="element-250">
              <X className="w-6 h-6" data-id="element-251" />
            </button>
          </div>

          <div className="flex-1 overflow-y-auto py-6 px-6 flex flex-col space-y-6" data-id="element-252">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-medium text-charcoal-text hover:text-terracotta" onClick={() => setIsMobileMenuOpen(false)} data-id="element-253">
                {link.name}
              </a>)}
          </div>

          <div className="p-6 border-t border-sand bg-sand/20" data-id="element-254">
            <a href="#" className="block w-full text-center bg-terracotta text-white py-4 rounded font-medium shadow-sm hover:bg-terracotta/90" data-id="element-255">
              Get Home Value
            </a>
            <div className="mt-6 text-sm text-muted-gray space-y-2" data-id="element-256">
              <p data-id="element-257">Office: 602.309.8888</p>
              <p data-id="element-258">Cell: 480.215.2324</p>
            </div>
          </div>
        </div>
      </div>
    </>;
}